// extracted by mini-css-extract-plugin
export var divider = "_20-0";
export var dividerText = "_20-2";
export var dividerVertical = "_20-1";